import { useState } from "react";
import { apiFetch } from "../services/api.js";
import { getUser } from "../services/auth.js";

export default function TabelaCampanhas({ campanhas, onRefresh }) {
  const [editando, setEditando] = useState(null);
  const [dados, setDados] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  function abrirEdicao(campanha) {
    setEditando(campanha.id);
    setDados({
      nome: campanha.nome,
      prefixo: campanha.prefixo || "",
      quantidade_maxima_cupons: campanha.quantidade_maxima_cupons || 0,
      quantidade_premios: campanha.quantidade_premios || 1,
    });
    setErro("");
    setSucesso("");
  }

  function cancelarEdicao() {
    setEditando(null);
    setDados({});
  }

  async function salvarEdicao(campanhaId) {
    setSalvando(true);
    setErro("");
    setSucesso("");

    try {
      // Validar campos obrigatórios
      if (!dados.nome?.trim()) throw new Error("Nome é obrigatório");
      if (!dados.prefixo?.trim()) throw new Error("Prefixo é obrigatório");
      if (!dados.quantidade_maxima_cupons || dados.quantidade_maxima_cupons < 1)
        throw new Error("Max cupons deve ser > 0");
      if (!dados.quantidade_premios || dados.quantidade_premios < 1)
        throw new Error("Premios deve ser > 0");

      await apiFetch(`campanhas/${campanhaId}`, {
        method: "PUT",
        body: JSON.stringify({
          nome: dados.nome,
          prefixo: dados.prefixo,
          quantidade_maxima_cupons: Number(dados.quantidade_maxima_cupons),
          quantidade_premios: Number(dados.quantidade_premios),
        }),
      });

      setSucesso("Campanha atualizada com sucesso!");
      setEditando(null);
      onRefresh && onRefresh();

      setTimeout(() => setSucesso(""), 3000);
    } catch (err) {
      setErro(err.message || "Erro ao atualizar campanha");
    } finally {
      setSalvando(false);
    }
  }

  async function handleDeletar(campanhaId) {
    if (
      !window.confirm(
        "Tem certeza que deseja excluir esta campanha e seus cupons?",
      )
    )
      return;
    try {
      await apiFetch(`campanhas/${campanhaId}`, { method: "DELETE" });
      onRefresh && onRefresh();
    } catch (err) {
      setErro(err.message || "Erro ao excluir campanha");
    }
  }

  async function toggleAtivo(campanha) {
    try {
      await apiFetch(`campanhas/${campanha.id}`, {
        method: "PUT",
        body: JSON.stringify({
          nome: campanha.nome,
          prefixo: campanha.prefixo,
          quantidade_maxima_cupons: campanha.quantidade_maxima_cupons,
          quantidade_premios: campanha.quantidade_premios || 1,
          ativo: !campanha.ativo,
        }),
      });
      onRefresh && onRefresh();
    } catch (err) {
      setErro(err.message || "Erro ao atualizar campanha");
    }
  }

  async function toggleArquivar(campanha) {
    try {
      await apiFetch(`campanhas/${campanha.id}`, {
        method: "PUT",
        body: JSON.stringify({
          nome: campanha.nome,
          prefixo: campanha.prefixo,
          quantidade_maxima_cupons: campanha.quantidade_maxima_cupons,
          quantidade_premios: campanha.quantidade_premios || 1,
          ativo: campanha.ativo,
          arquivado: !campanha.arquivado,
        }),
      });
      onRefresh && onRefresh();
    } catch (err) {
      setErro(err.message || "Erro ao arquivar campanha");
    }
  }

  if (!campanhas.length) {
    return <p>Nenhuma campanha cadastrada</p>;
  }

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Prefixo</th>
            <th>Max Cupons</th>
            <th>Prêmios</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {campanhas.map((campanha) =>
            editando === campanha.id ? (
              <tr key={campanha.id} style={{ backgroundColor: "#f8f9fa" }}>
                <td>
                  <input
                    type="text"
                    value={dados.nome}
                    onChange={(e) =>
                      setDados({ ...dados, nome: e.target.value })
                    }
                    style={{ width: "100%", padding: "0.5rem" }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={dados.prefixo}
                    onChange={(e) =>
                      setDados({
                        ...dados,
                        prefixo: e.target.value.toUpperCase(),
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderColor: dados.prefixo?.trim()
                        ? "#27ae60"
                        : "#e74c3c",
                      borderWidth: "2px",
                    }}
                    maxLength="10"
                    placeholder="Ex: TST"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min="1"
                    value={dados.quantidade_maxima_cupons}
                    onChange={(e) =>
                      setDados({
                        ...dados,
                        quantidade_maxima_cupons: e.target.value,
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderColor:
                        dados.quantidade_maxima_cupons > 0
                          ? "#27ae60"
                          : "#e74c3c",
                      borderWidth: "2px",
                    }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min="1"
                    value={dados.quantidade_premios}
                    onChange={(e) =>
                      setDados({
                        ...dados,
                        quantidade_premios: e.target.value,
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "0.5rem",
                      borderColor:
                        dados.quantidade_premios > 0 ? "#27ae60" : "#e74c3c",
                      borderWidth: "2px",
                    }}
                  />
                </td>
                <td>
                  <button
                    onClick={() => salvarEdicao(campanha.id)}
                    disabled={salvando}
                    style={{
                      backgroundColor: "#667eea",
                      color: "white",
                      border: "none",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "4px",
                      cursor: salvando ? "not-allowed" : "pointer",
                      marginRight: "0.5rem",
                    }}
                  >
                    {salvando ? "Salvando..." : "Salvar"}
                  </button>
                  <button
                    onClick={cancelarEdicao}
                    disabled={salvando}
                    style={{
                      backgroundColor: "#e74c3c",
                      color: "white",
                      border: "none",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancelar
                  </button>
                </td>
              </tr>
            ) : (
              <tr key={campanha.id}>
                <td>{campanha.nome}</td>
                <td>
                  <strong>{campanha.prefixo}</strong>
                </td>
                <td>{campanha.quantidade_maxima_cupons}</td>
                <td>{campanha.quantidade_premios || 1}</td>
                <td>
                  <button
                    onClick={() => abrirEdicao(campanha)}
                    style={{
                      backgroundColor: "#667eea",
                      color: "white",
                      border: "none",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "4px",
                      cursor: "pointer",
                      marginRight: "0.5rem",
                    }}
                  >
                    Editar
                  </button>
                  {/* show deactivate and delete only for admin */}
                  {getUser()?.role === "admin" && (
                    <>
                      <button
                        onClick={() => toggleAtivo(campanha)}
                        style={{
                          backgroundColor: campanha.ativo
                            ? "#f39c12"
                            : "#27ae60",
                          color: "white",
                          border: "none",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "4px",
                          cursor: "pointer",
                          marginRight: "0.5rem",
                        }}
                      >
                        {campanha.ativo ? "Desativar" : "Ativar"}
                      </button>
                      <button
                        onClick={() => toggleArquivar(campanha)}
                        style={{
                          backgroundColor: campanha.arquivado
                            ? "#95a5a6"
                            : "#34495e",
                          color: "white",
                          border: "none",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "4px",
                          cursor: "pointer",
                          marginRight: "0.5rem",
                        }}
                      >
                        {campanha.arquivado ? "Restaurar" : "Arquivar"}
                      </button>
                      <button
                        onClick={() => handleDeletar(campanha.id)}
                        style={{
                          backgroundColor: "#e74c3c",
                          color: "white",
                          border: "none",
                          padding: "0.4rem 0.8rem",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Excluir
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>

      {erro && (
        <p className="error-message" style={{ marginTop: "1rem" }}>
          {erro}
        </p>
      )}
      {sucesso && (
        <p
          style={{
            color: "#27ae60",
            fontWeight: "600",
            marginTop: "1rem",
          }}
        >
          {sucesso}
        </p>
      )}
    </div>
  );
}
